import { SvgIconProps } from '@mui/material';
import React from 'react';

import { APP_GUEST_ICON_ID, APP_PLACE_ICON_ID } from '@/constants/testIds';

import appGuestIcon from '../../images/icons/icon_app_guest.png';
import notificationIcon from '../../images/icons/icon_notification.png';
import placeIcon from '../../images/icons/icon_place.png';
import tableIcon from '../../images/icons/icon_table.png';
import Icon from './Icon';

export const AppGuestIcon = (props: React.ComponentProps<typeof Icon>) => <Icon {...props} src={appGuestIcon} data-id={APP_GUEST_ICON_ID} alt="guests login" />;

export const PlaceIcon = (props: React.ComponentProps<typeof Icon>) => <Icon {...props} src={placeIcon} data-id={APP_PLACE_ICON_ID} alt="Place" />;

export const NotificationIcon = (props: React.ComponentProps<typeof Icon>) => <Icon {...props} src={notificationIcon} alt="notification" />;

export const TableIcon = (props: SvgIconProps<'svg', object>) => <Icon {...props} classes={{}} src={tableIcon} alt="table" />;
